export const MASTERCARD = {
  id: 'mastercard',
  name: 'MasterCard',
  newName: 'Mastercard',
  code: '30',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/CO/franquicias/mastercard.svg'
};
export const VISA = {
  id: 'visa',
  name: 'Visa',
  code: '20',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/CO/franquicias/visa.svg'
};
export const AMEX = {
  id: 'amex',
  name: 'American Express',
  code: '40',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/CO/franquicias/amex.svg'
};
export const DINERS_CLUB = {
  id: 'diners',
  name: 'Diners Club',
  code: '50',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/CO/franquicias/diners.svg',
  modal: {
    title: 'INGRESA EL CÓDIGO ENVIADO POR TU BANCO O EMISOR',
    code: 'Código *',
    closeWindowDesc: 'La ventana se cerrará en',
    closeWindowDescPay: 'y el pago se cancelará',
    confirmButtonText: 'VERIFICAR Y PAGAR',
    cancelPayment: 'Cancelar pago',
    infoCode: 'Debes ingresar el código OTP!',
    minutesDesc: 'minuto(s) con',
    secondsDesc: 'segundos',
    errorCharacters: 'El código OTP debe contener mínimo 6 caracteres',
    infoCodePending: 'Verificación pendiente por favor intenta de nuevo',
    pendingMessagge: 'PENDIENTE'
  }
};
export const CODENSA = {
  id: 'codensa',
  name: 'Codensa',
  code: '60',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/CO/franquicias/codensa.png'
};
export const UNION_PAY = {
  id: 'union_pay',
  name: 'Union Pay',
  code: '70',
  logo: 'https://images.payvalida.com/logo_medio_recaudo/PE/UnionPay_logo.png'
};
export const CODE_RESPONSE = {
  TRANSACTION_CORRECT: '200',
  TRANSACTION_INCORRECT: '400',

}

export const TC_STATUS = {
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  ANTI_FRAUD_FAILED: 'ANTI_FRAUD_FAILED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
};


export const TC_FRANCHISE_FROM_FLUTTER = {
  'CardType.Master': 'MasterCard',
  'CardType.Visa': 'Visa',
  'CardType.AmericanExpress': 'American Express',
  'CardType.Diners': 'Diners',
  'CardType.Others': 'Otros',
  'CardType.Invalid': 'Ivalida',
}

const CREDIT_CARDS = [
  MASTERCARD,
  VISA,
  AMEX,
  DINERS_CLUB,
  CODENSA,
  UNION_PAY
];


export default CREDIT_CARDS;
